export default "__VITE_ASSET__DNgBb365__"